import React, { useEffect, useState } from "react"
import { Col, Form, Input, Label, Row } from "reactstrap"
import DatePicker from "react-flatpickr"
import InputMask from "react-input-mask"
import { isEmpty } from "lodash"
import Select from "react-select"
import { useDispatch } from "react-redux"
import { addManualEntryTimeLog, moveIdHoursTimeLog, changeStatusTimelog } from "store/actions"
import { Reasondropdown } from "common/data/settings"
import * as moment from "moment"

const MoveIdForm = props => {
  const { setModal, entryName, toSelectData, clickedRow, clickedRowToggle, formData, isVisibleTiming, getTimeLogByDate } = props

  const customStyles = error => ({
    control: provided => ({
      ...provided,
      border: error ? "1px solid #f46a6a" : "1px solid #FFDBB1",
      "&:hover": { border: error ? "1px solid #f46a6a" : "1px solid #FFDBB1" },
    }),
    option: (provided, state) => ({
      ...provided,
      // color: state.isSelected ? 'white' : 'black',
      background: state.isSelected ? "#e69138" : "white",
      "&:hover": {
        background: "#f4c896", // Change option background color on hover
        color: "#fff", // Change option text color on hover
      },
    }),
  })

  const dispatch = useDispatch()
  const clickRowStatus = clickedRow?.values?.activeStatusName === "IDLE" ? null : (clickedRow?.values?.activeStatusName === "ACTIVE" ? true : false)
  const [registerDate, setRegisterDate] = useState(clickedRowToggle ? formData?.Date : new Date())
  const [comments, setComments] = useState("")
  const [fromTime, setFromTime] = useState(clickedRowToggle ? moment(clickedRow?.values?.starttime).format('HH:mm:ss') : "")
  const [toTime, setToTime] = useState(clickedRowToggle ? moment(clickedRow?.values?.endtime).format('HH:mm:ss') : "")
  const [totalTime, setTotalTime] = useState(clickedRowToggle ? moment(clickedRow?.values?.duration).format('HH:mm:ss') : "")
  const [status, setStatus] = useState(clickedRowToggle ? clickRowStatus : true)
  const [errorText, setErrorText] = useState({})
  const [fromSelect, setFromSelect] = useState(clickedRowToggle ? toSelectData[toSelectData.findIndex((idx) => idx.value === clickedRow?.values?.accountName)] : undefined)
  const [toSelect, setToSelect] = useState(undefined)


  useEffect(() => {
    if (fromTime && toTime) {
      setTotalTime(timeDifference(fromTime, toTime))
    }
  }, [fromTime, toTime])


  const errorValidation = data => {
    const error = {};
    const isManualEntry = entryName === "Add Manual Entry";   
    const isEmptyFromSelect = isEmpty(data?.fromSelect);
    const isEmptyToSelect = isEmpty(data?.toSelect);

    if (isEmptyFromSelect) {
      error.fromSelect = `${isManualEntry ? "" : "From "}ID is empty`;
    }
    if (!data?.fromhrs) {
      error.fromHrs = "From Hrs is empty";
    }
    if (!data?.tohrs) {
      error.toHrs = "To Hrs is empty";
    }
    if (isEmptyToSelect) {
      error.toSelect = `${isManualEntry ? "Reason" : "To Do "} is empty`;
    }
    if (entryName !== "Change Status") {
      if (!isEmptyFromSelect && !isEmptyToSelect && data?.fromSelect?.accountId === (data?.toSelect?.accountId ? data?.toSelect?.accountId : data?.toSelect?.id)) {
        error.toSelect = error.fromSelect = `${isManualEntry ? "" : "Same ID"}`;
      }
    }
    if (!data?.comments) {
      error.comments = "Comments is empty";
    }
    if (data?.statusErr === null) {
      error.statusErr = "Status is empty";
    }
    return error;
  };

  const registerDateChange = date => {
    setRegisterDate(date)
  }

  const handleBlurTimeChange = (date, key) => {
    const selectedTime = moment.duration(date);
    const twentyFourHoursDuration = moment.duration(24, 'hours');
    const isGreaterThan24Hours = selectedTime.asMilliseconds() > twentyFourHoursDuration.asMilliseconds();
    if (key === "fromHrs" && isGreaterThan24Hours) {
      setFromTime("23:59:00")
    } if (key === "" && isGreaterThan24Hours) {
      setToTime("23:59:00")
    }
  }

  const timeDifference = (fromTime, toTime) => {
    const fromTimeParts = fromTime?.match(/(\d+):(\d+):(\d+)/)
    const toTimeParts = toTime?.match(/(\d+):(\d+):(\d+)/)

    if (fromTimeParts && toTimeParts) {
      const fromHours = parseInt(fromTimeParts[1])
      const fromMinutes = parseInt(fromTimeParts[2])
      const fromSeconds = parseInt(fromTimeParts[3])

      const toHours = parseInt(toTimeParts[1])
      const toMinutes = parseInt(toTimeParts[2])
      const toSeconds = parseInt(toTimeParts[3])

      const fromTimestamp = fromHours * 3600 + fromMinutes * 60 + fromSeconds
      const toTimestamp = toHours * 3600 + toMinutes * 60 + toSeconds

      let timeDifference = toTimestamp - fromTimestamp

      if (timeDifference < 0) {
        // If the "to time" is earlier than the "from time," it's likely a time on the next day
        timeDifference += 24 * 3600
      }

      const hours = Math.floor(timeDifference / 3600)
      const minutes = Math.floor((timeDifference % 3600) / 60)
      const seconds = timeDifference % 60

      const formattedHours = hours.toString().padStart(2, "0")
      const formattedMinutes = minutes.toString().padStart(2, "0")
      const formattedSeconds = seconds.toString().padStart(2, "0")
      const formattedTotalTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`

      return formattedTotalTime
    }
  }

  const handleSave = () => {

    if (clickedRow?.values?.activeStatusName !== "IDLE") {
      var tempError = {
        fromSelect: fromSelect,
        comments: comments,
        fromhrs: fromTime,
        tohrs: toTime,
        toSelect: toSelect,
        statusErr: status
      }
    } else {
      var tempError = {
        fromSelect: fromSelect,
        comments: comments,
        fromhrs: fromTime,
        tohrs: toTime,
        toSelect: toSelect,
      }
    }
    let check = errorValidation(tempError)
    if (isEmpty(check)) {
      if (entryName === "Add Manual Entry") {
        const reqObj = {
          id: 0,
          accountid: fromSelect?.accountId,
          date: moment(new Date(registerDate)).format(),
          startTime: moment(`${moment(new Date(registerDate)).format('YYYY-MM-DD')} ${fromTime}`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ssZ'),
          endTime: moment(`${moment(new Date(registerDate)).format('YYYY-MM-DD')} ${toTime}`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ssZ'),
          changeStatusReasonId: toSelect?.id,
          comments: comments
        }
        const manualEntryCallback = (data) => {
          if (data?.message === "Manual Hours Inserted Successfully") {
            getTimeLogByDate()
          }
          setModal(false)
        }
        dispatch(addManualEntryTimeLog(reqObj, manualEntryCallback))

      } else if (isVisibleTiming) {
        const reqObj = {
          id: 0,
          accountid: fromSelect?.accountId,
          date: moment(new Date(registerDate)).format(),
          startTime: moment(`${moment(new Date(registerDate)).format('YYYY-MM-DD')} ${fromTime}`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ssZ'),
          endTime: moment(`${moment(new Date(registerDate)).format('YYYY-MM-DD')} ${toTime}`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ssZ'),
          toStatus: status ? 1 : 2,
          changeStatusReasonId: toSelect?.id,
          comments: comments
        }
        const changeStatusCallback = (data) => {
          if (data?.message === "Status changed successfully") {
            getTimeLogByDate()
          }
          setModal(false)
        }
        dispatch(changeStatusTimelog(reqObj, changeStatusCallback)) 
      }
      else {
        const reqObj = {
          id: 0,
          sourceAccountId: fromSelect?.accountId,
          destinationAccountId: toSelect?.accountId,
          date: moment(new Date(registerDate)).format(),
          startTime: moment(`${moment(new Date(registerDate)).format('YYYY-MM-DD')} ${fromTime}`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ssZ'),
          endTime: moment(`${moment(new Date(registerDate)).format('YYYY-MM-DD')} ${toTime}`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ssZ'),
          isStatusChecked: true,
          toStatus: status ? 1 : 2,
          changeStatusReasonId: 0,
          comments: comments,
        }
        const moveIDCallback = (data) => {
          if (data?.message === "Hours Moved Successfully") {
            getTimeLogByDate()
          }
          setModal(false)
        }
        dispatch(moveIdHoursTimeLog(reqObj, moveIDCallback))
      }
    }
    setErrorText(check)
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSave()
        return false
      }}
    >
      <Row form>
        <Col className="col-12">
          <Row>
            <Col sm={6}>
              <div className="mb-3">
                <Label className="form-label">
                  {(entryName === "Add Manual Entry") ? (isVisibleTiming ? "From" : "") : "From "}ID
                </Label>
                <Select
                  isClearable
                  value={fromSelect}
                  placeholder={
                    fromSelect
                      ? fromSelect
                      : `Select a ${entryName === "Add Manual Entry" ? "ID" : "From ID"
                      }`
                  }
                  onChange={value => setFromSelect(value)}
                  options={toSelectData}
                  // classNamePrefix="select2-selection"
                  className="add_Zindex_three"
                  styles={customStyles(errorText.fromSelect)}
                  defaultValue={clickedRowToggle && toSelectData[toSelectData.findIndex((idx) => idx.label === clickedRow?.values?.categoryName)]}
                  isDisabled={clickedRowToggle}
                />
                <span className="invalid-custom">{errorText.fromSelect}</span>
              </div>
            </Col>
            {!isVisibleTiming && <Col sm={6}>
              <div className="mb-3">
                <Label className="form-label">Date</Label>
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  // selected={registerDate}
                  value={registerDate}
                  onChange={registerDateChange}
                  className="form-control mb-0 date-icon-back"
                  placeholderText="Select date"
                  maxDate={new Date()}
                  disabled={clickedRowToggle}
                />
              </div>
            </Col>}
          </Row>

          <Row>
            {!isVisibleTiming && <Col sm={6} className="d-flex">
              <Col sm={6}>
                <div className="mb-3 marr1">
                  <Label className="form-label">From Hrs</Label>
                  <InputMask
                    mask="99:99:99"
                    id="fromhrs"
                    name="fromhrs"
                    className={`form-control input-color ${!errorText.fromHrs ? "" : "custom-border-red"
                      }`}
                    placeholder="HH:mm:ss"
                    onChange={e => setFromTime(e.target.value)}
                    onBlur={e => handleBlurTimeChange(e.target.value, "fromHrs")}
                    value={fromTime}
                    disabled={clickedRowToggle}
                  />
                  <span className="invalid-custom">{errorText.fromHrs}</span>
                </div>
              </Col>
              <Col sm={6}>
                <div className="mb-3 marl1">
                  <Label className="form-label">To Hrs</Label>
                  <InputMask
                    id="tohrs"
                    name="tohrs"
                    mask="99:99:99"
                    placeholder="HH:mm:ss"
                    className={`form-control input-color ${!errorText.toHrs ? "" : "custom-border-red"
                      }`}
                    onChange={e => setToTime(e.target.value)}
                    onBlur={e => handleBlurTimeChange(e.target.value, "")}
                    value={toTime}
                    disabled={clickedRowToggle}
                  />
                  <span className="invalid-custom">{errorText.toHrs}</span>
                </div>
              </Col>
            </Col>}
            <Col sm={6}>
              <div className="mb-3">
                <Label className="form-label">{isVisibleTiming ? "Time" : "Total"}</Label>
                <InputMask
                  mask="99:99:99"
                  placeholder="HH:mm:ss"
                  disabled
                  // value={props.value}
                  value={totalTime || ""}
                  className="form-control input-color"
                // onChange={props.onChange}
                ></InputMask>
              </div>
            </Col>
            {isVisibleTiming && <Col sm={6}>
              <div className="mb-3">
                <Label className="form-label">Status</Label>
                <Input
                  type="text"
                  name="activeStatusName"
                  value={clickedRow?.values?.activeStatusName}
                  disabled
                />
              </div>
            </Col>}
          </Row>
          <Row>
            <Col sm={6}>
              <div className="mb-3">
                <Label className="form-label">
                  {entryName === "Add Manual Entry" ? "Reason" : (isVisibleTiming ? "Reason" : "To ID")}
                </Label>
                <Select
                  isClearable
                  value={toSelect}
                  placeholder={
                    toSelect
                      ? toSelect
                      : `Select a ${entryName === "Add Manual Entry" ? "Reason" : "To Do "
                      }`
                  }
                  onChange={value => setToSelect(value)}
                  options={(entryName === "Add Manual Entry" ? Reasondropdown : (isVisibleTiming ? Reasondropdown : toSelectData))}
                  // classNamePrefix="select2-selection"
                  className="add_Zindex_three"
                  styles={customStyles(errorText.toSelect)}
                />
                <span className="invalid-custom">{errorText.toSelect}</span>
              </div>
            </Col>
            {entryName !== "Add Manual Entry" && <Col sm={3}>
              <div className={errorText.statusErr && 'mb-3'} >
                <Label className="d-block mb-3">{isVisibleTiming ? "Change To" : "Status"}</Label>
                <div className="form-check form-check-inline">
                  <Input
                    type="radio"
                    onChange={value => setStatus(true)}
                    defaultChecked={clickedRowToggle ? clickRowStatus : true}
                    name="active"
                    className="form-check-input"
                    id="active1"
                  />
                  <Label className="form-check-label" htmlFor="active1">
                    Active
                  </Label>
                </div>
                &nbsp;
                <div className="form-check form-check-inline">
                  <Input
                    type="radio"
                    onChange={value => setStatus(false)}
                    defaultChecked={clickedRowToggle ? (clickRowStatus === null ? null : !clickRowStatus) : false}
                    name="active"
                    className="form-check-input"
                    id="active2"
                  />
                  <Label className="form-check-label" htmlFor="active2">
                    Private
                  </Label>
                </div>
              </div>
              <span className="invalid-custom">{errorText.statusErr}</span>
            </Col>}
          </Row>
          <textarea
            className={`form-control ${!errorText.comments ? "mb-3" : "custom-border-red"
              }`}
            rows="3"
            placeholder="Comments"
            onChange={e => setComments(e.target.value)}
          />
          <span className="invalid-custom">{errorText.comments}</span>
        </Col>
        <Row>
          <Col>
            <div className="text-end">
              <button type="submit" className="btn btn-primary save-user me-2">
                Save
              </button>
              <button
                type="button"
                color="primary"
                className="btn btn-secondary"
                onClick={() => setModal(false)}
              >
                Cancel
              </button>
            </div>
          </Col>
        </Row>
      </Row>
    </Form>
  )
}

export default MoveIdForm